module.exports = __webpack_public_path__ + "img/bq.svg";